import { useState } from 'react';
import { VictoryPie } from 'victory';
import NoData from '../../../../../../components/NoData';
import OpacityAnimation from '../../../../../../components/OpacityAnimation';
import useThemeContext from '../../../../../../contexts/theme';
import { Card } from './styles';

interface OptimizedEmployeesCardI {
  optimized: number;
  total: number;
}

export default function OptimizedEmployeesCard({
  optimized,
  total,
}: OptimizedEmployeesCardI) {
  const { selectedTheme } = useThemeContext();
  const [labelBeingShow, setLabelBeingShow] = useState({ description: '', value: '' });

  return (
    <Card>
      <div className="card-title">
        <div>Funcionários Otimizados X Total</div>
      </div>

      {(!!total) && (
        <>
          <OpacityAnimation>
            <div className="card-main-graph">
              <VictoryPie
                data={[
                  { x: 'Não Otimizados', y: (total - optimized) },
                  { x: 'Otimizados', y: optimized }
                ]}
                animate={{
                  duration: 500
                }}
                colorScale="qualitative"
                height={335}
                labelPlacement="vertical"
                labelRadius={0.1}
                labelPosition="endAngle"
                style={{
                  labels: { fontSize: 0, fill: selectedTheme === 'dark' ? '#fff' : '#000' }
                }}
                padding={{ top: 0, bottom: 10 }}
                innerRadius={110}
                padAngle={1}
                events={[{
                  target: 'data',
                  eventHandlers: {
                    onMouseOver: () => {
                      return [
                        {
                          target: 'data',
                          mutation: ({ style, data, index }) => {
                            setLabelBeingShow({ description: data[index].x, value: data[index].y?.toFixed(0) });
                            return { style: Object.assign({}, style, { opacity: '0.8', cursor: 'help' }) };
                          }
                        }
                      ];
                    },
                    onMouseOut: () => {
                      return [
                        {
                          target: 'data',
                          mutation: () => {
                            setLabelBeingShow({ description: '', value: '' });
                            return null;
                          }
                        }
                      ];
                    }
                  }
                }]}
              />
              <label>
                <span>{labelBeingShow.value ? labelBeingShow.value : ''}</span>
                <span>{labelBeingShow.description}</span>
              </label>
            </div>
          </OpacityAnimation>
        </>
      )}

      {(!total) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não há dados de otmização de funcionários para o período selecionado
            </>
          )}
        />
      )}
    </Card>
  );
}
